import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    tierCardContainer: {
        marginTop: '15px',
    },
}));

export default useStyles;
